import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { Select } from '@bufferapp/ui';
import styled from 'styled-components';
import { onSelectAllClick, getCustomChannels } from './generateFilterItems';
import GET_CHANNELS_QUERY from '../graphql/channels';
import useTrackFilteredChannels from '../hooks/useTrackFilteredChannels';

const Wrapper = styled.span`
  min-width: 126px;
`;

const ChannelFilter = ({
  channelFilter,
  channelSelected,
  isWeekly,
  trackChannelsFiltered,
}) => {
  const { setChannels, channelsSelected } = channelFilter;
  const { data, loading } = useQuery(GET_CHANNELS_QUERY);

  const channels = data?.account?.currentOrganization?.channels || [];

  useTrackFilteredChannels({
    channels,
    channelsSelected,
    isWeekly,
    track: trackChannelsFiltered,
  });
  // Select label
  const numberOfChannelsSelected = channelsSelected.length;
  const allChannelsAreSelected = numberOfChannelsSelected === channels.length;
  const labelForSoloChannels = `${numberOfChannelsSelected} ${
    numberOfChannelsSelected === 1 ? 'channel' : 'channels'
  }`;
  const label = allChannelsAreSelected ? 'All channels' : labelForSoloChannels;

  // Select default filter values
  useEffect(() => {
    // Filter by one channel if coming from route with channel state (e.g. queue)
    if (channelSelected) {
      setChannels([channelSelected]);
      // Or select all channels
    } else if (numberOfChannelsSelected === 0 && !loading) {
      onSelectAllClick({ setChannels, channels });
    }
    // FIXME: Remove comment below to see warning
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  // Hide if only one channel available
  if (channels.length === 1) {
    return <></>;
  }

  return (
    <Wrapper>
      <Select
        onSelectClick={(selectedItem) => {
          selectedItem.onItemClick({
            currentState: channelsSelected,
          });
        }}
        label={label}
        searchPlaceholder="Search"
        items={getCustomChannels({
          channels,
          setChannels,
          channelsSelected,
        })}
        multiSelect
        disabled={loading}
        xPosition="right"
        capitalizeItemLabel={false}
        keyMap={{ id: 'id', title: 'name' }}
        fullWidth
        clearSearchOnBlur
        searchInputProps={{
          clearSearchOnBlur: false,
        }}
      />
    </Wrapper>
  );
};

ChannelFilter.propTypes = {
  channelFilter: PropTypes.shape({
    channelsSelected: PropTypes.arrayOf(PropTypes.string),
    setChannels: PropTypes.func,
  }).isRequired,
  channelSelected: PropTypes.string,
  isWeekly: PropTypes.bool.isRequired,
  trackChannelsFiltered: PropTypes.func.isRequired,
};

ChannelFilter.defaultProps = {
  channelSelected: '',
};

export default ChannelFilter;
